import { render, staticRenderFns } from "./advancedSliceEditor.vue?vue&type=template&id=55927dec&"
import script from "./advancedSliceEditor.vue?vue&type=script&lang=js&"
export * from "./advancedSliceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/path0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55927dec')) {
      api.createRecord('55927dec', component.options)
    } else {
      api.reload('55927dec', component.options)
    }
    module.hot.accept("./advancedSliceEditor.vue?vue&type=template&id=55927dec&", function () {
      api.rerender('55927dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/advancedSliceEditor.vue"
export default component.exports